import { Table } from 'redesign';
import { TakeDefined } from '@types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetStatistics } from 'ogp/hooks/queryHooks/statistics/use-get-statistics';
import { FlexPoolsTableColumnDefinition } from './helpers/flex-pools-table.types';
import { getFlexPoolsColumnDefinition } from './helpers/get-flex-pools-column-definition';
import { getFlexPoolsTableData } from './helpers/get-flex-pools-table-data';
import { useGetInternalFlexPools } from '../../../hooks/use-get-internal-flex-pools';

type Props = {
  data: TakeDefined<ReturnType<typeof useGetInternalFlexPools>['data']>;
  onRowClick: (row: FlexPoolsTableColumnDefinition) => void;
};

export const FlexPoolsTable = ({ data, onRowClick }: Props) => {
  const { t } = useTranslation('ogp-screen-specific');
  const { data: statisticsData } = useGetStatistics('flex-pools');
  const columns = useMemo(
    () => getFlexPoolsColumnDefinition(t, statisticsData),
    [t, statisticsData]
  );
  const tableData = useMemo(() => getFlexPoolsTableData(data), [data]);

  return (
    <Table<FlexPoolsTableColumnDefinition>
      columns={columns}
      data={tableData}
      onRowClick={onRowClick}
    />
  );
};
